/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/role-has-required-aria-props */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/api';
import s from './FuelWidget.module.scss';
import { Button } from 'ui';
import Search from '../../../../components/common/search/search';

const url = `${apiConfig('vehicleVerticals')}/v1/cities/`;
type FuelTypes = {
  data: {
    cities: any[];
  };
};

export const FuelWidget = ({ data }: FuelTypes) => {
  const [input, setInput] = useState('');
  const [suggestionDiv, setSuggestionDiv] = useState(false);
  const [suggestion, setSuggestion] = useState([]);
  const [states, setData] = useState(data?.cities);
  const router = useRouter();

  const getData = async () => {
    const { response: data, error }: any = await getMethod(url);

    return data;
  };

  useEffect(() => {
    if (!data?.cities) {
      getData().then((res) => {
        setData(res?.data?.cities);
      });
    }
  }, []);

  function handleInputChange(value) {
    setInput(value);
    setSuggestionDiv(true);
    const query = value.toLowerCase(value);
    if (query?.length > 0) {
      setSuggestion(
        states.filter((item) => item.name.toLowerCase().includes(query))
      );
    } else {
      setSuggestion([]);
    }
  }

  function handleSubmitClick(e) {
    if (router.query.slug) {
      window.location.href = `petrol-diesel-price-in-${input
        .toLowerCase()
        .replace(/ /g, '-')}`;
    } else
      window.location.href = `fuel-price/petrol-diesel-price-in-${input
        .toLowerCase()
        .replace(/ /g, '-')}`;
  }

  function handleSelectionClick(value) {
    setInput(value);
    setSuggestionDiv(false);
  }

  return (
    <section className={s.root}>
      <div className={s.heading}>Enter place to get fuel prices</div>
      <div className={s.search_bar}>
        <Search
          onChange={handleInputChange}
          setFocus={() => {}}
          value={input}
          onCancelClick={() => {}}
          placeholder="Enter place"
          styleType="rounded"
        />

        {suggestion?.length > 0 && suggestionDiv && (
          <ol
            aria-labelledby="ss_elem"
            role="listbox"
            className={s.suggestion_div}
          >
            {suggestion?.map((e, i) => (
              <li
                role="option"
                className={s.suggestion_item}
                key={i}
                style={{ listStyle: 'none' }}
                onClick={() => handleSelectionClick(e.name)}
              >
                {e.name}
              </li>
            ))}
          </ol>
        )}
      </div>

      <div className={s.button_wrapper}>
        <Button
          label="Get fuel prices"
          customStyle={{ width: '100%' }}
          onClick={handleSubmitClick}
        />
      </div>
    </section>
  );
};
